import React, { useEffect, useState } from "react";
import "../login/login.css";
import Cookies from "js-cookie";
import axios from "axios";
import Home from "../../User/Home/Home";
import {
  loadCaptchaEnginge,
  LoadCanvasTemplate,
  validateCaptcha,
} from "react-simple-captcha";
import { Buffer } from 'buffer';
import { useNavigate } from "react-router-dom";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loginResponse, setLoginResponse] = useState(null);
  const [rememberMe, setRememberMe] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [captchaValue, setCaptchaValue] = useState(null);
  const [userDetails, setUserDetails] = useState(null);
  const navigate=useNavigate();

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleCheckboxChange = () => {
    setRememberMe(!rememberMe);
  };

  const baseAPI = process.env.REACT_APP_API_URL;

  useEffect(() => {   
window.scrollTo(0,0)
    const storedToken = JSON.parse(localStorage.getItem("token"));
    const storedUserDetails = {
      name: localStorage.getItem("name"),
      designation: localStorage.getItem("designation"),
      is_sales: JSON.parse(localStorage.getItem("is_sales")),
      is_account: JSON.parse(localStorage.getItem("is_account")),
      is_operation: JSON.parse(localStorage.getItem("is_operation")),
      is_HR: JSON.parse(localStorage.getItem("is_HR")),
      is_master: JSON.parse(localStorage.getItem("is_master")),
    };

    if (storedToken && storedUserDetails) {
      setLoginResponse({ data: { access_token: storedToken } });
      setUserDetails(storedUserDetails);
    }

    const userName = Cookies.get("emailToken");
    const pwd = Cookies.get("passwordToken");
    if (userName) {
      setEmail(userName);
      setPassword(pwd);
    }

    loadCaptchaEnginge(4);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const requestBody = {
      email: email,
      password: password,
    };

    if (validateCaptcha(captchaValue) === true) {
      if (rememberMe) {
        Cookies.set("emailToken", email, { expires: 7 });
        Cookies.set("passwordToken", password, { expires: 7 });
      }

      localStorage.setItem("credentials", JSON.stringify(requestBody));

      try {
        const response = await fetch(`${baseAPI}auth/weblogin`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        });

        const responseData = await response.json();

        if (response.ok) {
          localStorage.setItem(
            "token",
            JSON.stringify(responseData.data.access_token)
          );
          const userResponse = await axios.get(
            `${baseAPI}adminget/GETUserDetail`,
            {
              headers: {
                Authorization: `Bearer ${responseData.data.access_token}`,
              },
            }
          );
          
          const userData = userResponse.data.data[0];
          
          localStorage.setItem("name", userData.name);
          localStorage.setItem("designation", userData.Designation);
          localStorage.setItem("isAdmin", userData.is_admin);
          localStorage.setItem("Dept_ID", userData.Dept_ID);
          localStorage.setItem("Desg_ID", userData.Desg_ID);  
          localStorage.setItem("is_sales", userData.is_sales);
          localStorage.setItem("is_account", userData.is_account);
          localStorage.setItem("is_operation", userData.is_operation);
          localStorage.setItem("is_HR", userData.is_HR);
          localStorage.setItem("is_master", userData.is_master);
          
          navigate('/admin/dashboard')
          setUserDetails(userData);
          setLoginResponse(responseData);
        } else {
          alert("Login credential not matched!!");
        }
      } catch (error) {
        console.error("An error occurred:", error);
      }
    } else {
      alert("Captcha Does Not Match");
    }
  };

  // if (loginResponse && userDetails) {
  //   if (userDetails.is_sales) return <Home/>;
  //   return <Home/>;
  // } else {
    return (
      <div className="container-fluid-login">
        {/* <div className="img-container"></div> */}

        <div className="form-container">
          <form onSubmit={handleSubmit} className="login-form">
            <img
              alt="Loading..."
              className="form-image img-fluid"
              src={require('../../../images/logo.png')}
              style={{ background: "white",objectFit:'cover' }}
            /> 
            <div className="form-group">
              <h4>Log In</h4>
              <input
                type="email"
                className="form-control"
                id="exampleInputEmail1"
                aria-describedby="emailHelp"
                placeholder="User Name"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <br />
            <div className="form-group">
              <div style={{ position: "relative" }}>
                <input
                  type={showPassword ? "text" : "password"}
                  className="form-control"
                  id="exampleInputPassword1"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <a
                  type="button"
                  onClick={togglePasswordVisibility}
                  style={{
                    position: "absolute",
                    right: "3.5%",
                    top: "50%",
                    transform: "translateY(-50%)",
                    border: "none",
                    background: "none",
                    cursor: "pointer",
                  }}
                >
                  {/* <RemoveRedEyeIcon className="icon" /> */}
                </a>
              </div>
              <br />
              <div className="form-group">
                <div
                  className="captcha-container"
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div>
                    <LoadCanvasTemplate />
                  </div>
                  <div className="form-group">
                    <input
                      className="form-control"
                      value={captchaValue}
                      type="text"
                      onChange={(e) => setCaptchaValue(e.target.value)}
                      placeholder="enter captcha"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              style={{
                marginTop: "2rem",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <button type="submit" className="btn btn-primary">
                Log In
              </button>
              <div className="form-check" style={{ marginTop: "0.5rem" }}>
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="checkbox1"
                  name="rememberMe"
                  checked={rememberMe}
                  onChange={handleCheckboxChange}
                />
                Remember me
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  // }
};

export default Login;
